module.exports = __webpack_public_path__ + "img/setting.a5a72b6b.svg";